/**
 * Trigger a browser "Save As" for an in-memory Blob.
 *
 * @param {Blob} blob
 * @param {string} filename
 */
export const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
